<template>
<div>
     <v-row class="pr-2 pl-2" no-gutters>
        <v-col justify="start" align="start" cols="2">
          <v-select
            v-model="selectedClientId"
            :items="clientList"
            item-text="name"
            item-value="clientId"
            label="Client"
          ></v-select>
        </v-col>
        <v-col justify="end" align="end" cols="3" class="offset-2">
          <v-menu
            ref="menu_startDateTime"
            v-model="startDateTimeMenu"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startDateTime"
                label="Start Date"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDateTime"
              no-title
              @input="startDateTimeMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col justify="end" align="end" cols="3">
          <v-menu
            ref="menu_endDateTime"
            v-model="endDateTimeMenu"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="endDateTime"
                label="End Date"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDateTime"
              no-title
              @input="endDateTimeMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col justify="end" align="end" cols="2">
          <v-btn tile color="primary" @click="loadAllReports()">Update</v-btn>
        </v-col>
      </v-row>
      <v-row class="pb-3" no-gutters>
        <v-col v-for="report in reports" :key="report.name" :cols="report.cols">
          <div class="ma-2">
            <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
              <h2 class="pb-4 pt-4">{{ report.heading }}</h2>
            </v-row>
            <v-data-table
              disable-filtering
              :hide-default-footer="true"
              disable-sort
              class="wz_data_table elevation-2"
              dense
              :loading="!report.loaded"
              :headers="headers[report.name]"
              :items="reportData[report.name]"
              item-key="name"
            >
              <template v-slot:header.SUCCESSRATE="{ header }">
                {{ header.text }} 
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="info" v-bind="attrs" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>The sum of leads captured and CTAs actioned as a percentage of CTs served</span>
                </v-tooltip>
              </template>
              <template
                v-if="report.showTotal"
                v-slot:body.append="{ headers }"
              >
                <tr>
                  <td v-for="(header, i) in headers" :key="i">
                    <div v-if="i === 0">Total</div>

                    <div
                      class="font-weight-bold"
                      v-else-if="header.type !== 'string' && reportData[report.name]"
                    >
                      {{
                        reportData[report.name]
                          .map((d) => d[headers[i].value])
                          .reduce((sum, val) => (sum += val), 0)
                      }}
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>
        <v-col>
          <div class="ma-2">
            <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
              <div class="header">
                <h2 class="pb-4 pt-4">Product Features</h2>
                <div class="note">Due to caching be aware changes may not take effect instantly.</div>
              </div>
            </v-row>
            <v-data-table
              disable-filtering
              :hide-default-footer="true"
              disable-sort
              disable-pagination
              class="wz_data_table elevation-2"
              :loading="productFeaturesLoading"
              :headers="headers['productFeatures']"
              :items="productFeatures"
              item-key="name"
            >
            <template v-slot:item="row">
              <tr>
                <td>
                  {{ row.item.productFeatureID }}                  
                </td>
                <td>
                  {{ row.item.name }}                  
                </td>
                <td>
                  {{ row.item.enabled }}                  
                </td>
                <td>
                  <v-btn class="button" @click="setProductFeature(row.item.productFeatureID, !featureEnabled(row.item))">
                    {{ featureEnabled(row.item) ? 'Disable' : 'Enable' }}
                  </v-btn>      
                </td>
              </tr>
            </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
      </div>
</template>
<script>
import api from "../services/support.api";

export default {
  data: () => {
    return {
      startDateTimeMenu: false,
      endDateTimeMenu: false,
      productFeaturesLoading: true,
      reports: [
        {
          name: "device",
          heading: "Device Breakdown",
          loaded: false,
          showTotal: true,
          cols: 12,
        },
        {
          name: 'deviceSessions',
          heading: 'Sessions by Device',
          loaded: false,
          showTotal: true,
          cols: 12,
        },
        {
          name: "popupEvents",
          heading: "Popup Events",
          loaded: false,
          showTotal: true,
          cols: 12,
        },
        {
          name: "leadEvents",
          heading: "Lead Event Report",
          loaded: false,
          showTotal: true,
          cols: 12,
        },
        {
          name: "top5pagesPopped",
          heading: "Top 5 Pages by popup",
          loaded: false,
          showTotal: false,
          cols: 12,
        },
        {
          name: "top5pagesLeads",
          heading: "Top 5 Pages by leads",
          loaded: false,
          showTotal: false,
          cols: 12,
        },
      ],
      selectedClientId: 13,
      startDateTime: new Date().toISOString().substr(0, 10),
      endDateTime: new Date().toISOString().substr(0, 10),
      clientList: [{ name: "Citation", id: 13 }],
      reportData: {
        device: [],
        popupEvent: [],
      },
      productFeatures: [],
      headers: {
        device: [
          { text: "Device", value: "DEVICE" },
          { text: "Available Traffic", value: "TOTALAVAILABLETRAFFIC" },
          { text: "Unique Traffic", value: "UNIQUETRAFFIC" },
          { text: "Repeat Traffic", value: "REPEATTRAFFIC" },
          { text: "Filtered Traffic", value: "FILTEREDTRAFFIC" },
          { text: "Failed To INIT", value: "FAILEDTOINIT" },
          {
            text: "Available To Serve",
            value: "AVAILABLETOSERVE",
          },
          { text: "Exit without event", value: "PAGEEXITWITHOUTEVENT" },
          { text: "CTs served", value: "POPUPSSERVED" },
          { text: "CTs suppressed", value: "POPUPSUPPRESSED" },
          { text: "Leads captured", value: "LEADSCAPTURED" },
          { text: "CTAs actioned", value: "CTAACTIONED" },
          { text: "Success Rate", value: "SUCCESSRATE", type: "string" },
        ],
        deviceSessions: [
          { text: "Device", value: "DEVICE" },
          { text: "Available Traffic", value: "TOTALAVAILABLETRAFFIC" },
          { text: "Unique Traffic", value: "UNIQUETRAFFIC" },
          { text: "Repeat Traffic", value: "REPEATTRAFFIC" },
          { text: "Leads captured", value: "LEADSCAPTURED" },
          { text: "Conversion Rate", value: "CONVERSIONRATE", type: "string" },          
          { text: "CTAs actioned", value: "CTAACTIONED" },
          { text: "Success Rate", value: "SUCCESSRATE", type: "string" },          
        ],
        filteredSessions: [
          { text: "Reason", value: "REASON", type: "string" },
          { text: "Sessions", value: "SESSIONS" },
        ],
        popupEvents: [
          { text: "Event Name", value: "EVENTNAME" },
          { text: "Popups Served", value: "POPS" },
        ],
        leadEvents: [
          { text: "Event Name", value: "EVENTNAME" },
          { text: "Leads captured", value: "LEADSCAPTURED" },
        ],
        top5pagesPopped: [
          { text: "Page Location", value: "LOCATION" },
          { text: "Page Title", value: "TITLE", type: "string" },
          { text: "Popups Served", value: "POPS" },
        ],
        top5pagesLeads: [
          { text: "Page Location", value: "LOCATION", width: 100 },
          { text: "Page Title", value: "TITLE", type: "string" },
          { text: "Leads Captured", value: "LEADS" },
        ],
        productFeatures: [
          { text: "FeatureId", value:'productFeatureID' },
          { text: "Feature", value:'name' },
          { text: "Enabled", value:'enabled' },
          { text: "Action"},
        ]
      },
    };
  },
  methods: {
    async getReport(name) {
      this.reports.find((r) => r.name === name).loaded = false;

      this.reportData[name] = await api.getReport(
        name,
        this.selectedClientId,
        this.startDateTime,
        this.endDateTime
      );

      this.reports.find((r) => r.name === name).loaded = true;
    },
    async getProductFeatures() {
      this.productFeaturesLoading = true;
      this.productFeatures = await api.getProductFeatures(this.selectedClientId);
      this.productFeaturesLoading = false;
    },
    async setProductFeature(featureId, enabled) {
      this.productFeaturesLoading = true;
      await api.setProductFeature(this.selectedClientId, featureId, enabled);
      await this.getProductFeatures();
    },
    loadAllReports() {
      for (let i = 0; i < this.reports.length; i++) {
        this.getReport(this.reports[i].name);
      }
      this.getProductFeatures();
    },
    async getClientList() {
      this.clientList = await api.getClientList();
    },
    featureEnabled(feature) {
      return feature.enabled;
    },
  },
  async mounted() {
    await this.getClientList();
    this.loadAllReports();
  },
};
</script>
<style>
.button {
  min-width: 120px !important;
}

.header{
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.note {
  align-content: center;
  padding-right: 16px;
}

.wz_data_table td {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
}

.wz_data_table {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  height: calc(100% - 68px);
}

.wz_table_header {
  background-color: #edf3fb;
  color: #424242;
  height: 68px;
}
</style>